import React from 'react';
import PropTypes from 'prop-types';

import { colorBlack } from 'styles/layout/colors';

const IconShare = ({ color = colorBlack, ...props }) => (
  <svg width={20} height={18} {...props}>
    <path
      d="M1.3 6.05l8.775 9.3.05.05L18.7 6.075v10.4H1.3V6.05zm.85-1h1.425v1.5L2.15 5.05zm14.25 0h1.45L16.4 6.625V5.05zM4.9 7.95V1.525h10.2V8.05l-5 5.425L4.9 7.95zM3.575.225V3.75H0v14.025h20V3.75h-3.575V.225H3.575z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

IconShare.propTypes = {
  color: PropTypes.string,
};

export default IconShare;
